import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import MultiStepFormContext from "~/contexts/MultiSelectForm/MultiSelectFormContext";
import Button from "~/shared/Btn";
import TextareaInput from "~/shared/TextareaInput";
import NumberInput from "~/shared/NumberInput";
import { Content, Header, Footer } from "../styles";
import { Row, Col } from "react-bootstrap";

type FormaturaProps = {
    prevStep?: () => void;
    nextStep?: () => void;
    goToStep?: (step: number) => void;
    currentStep: number;
};

const extraFields = {
    number_dishes: {
        name: "Numero de pratos",
        value: "",
        type: "numero",
    },
    photos_per_dishes: {
        name: "Fotos por pratos",
        value: "",
        type: "texto",
    },
    number_drinks: {
        name: "Numero de bebidas",
        value: "",
        type: "numero",
    },
    photos_per_drinks: {
        name: "Fotos por bebida",
        value: "",
        type: "texto",
    },
    adicional_info: {
        name: "Informações adicionais",
        value: "",
        type: "texto",
    },
};

const Foods = ({ nextStep, goToStep }: FormaturaProps) => {
    const { values, confirmationStep, handleChange, updateValuesInLocalStorage, setValues } =
        useContext(MultiStepFormContext);

    const [addicionalInfo, setAddicionalInfo] = useState<string>(values?.extra?.adicional_info?.value || "");
    const [numberDishes, setNumberDishes] = useState<string>(values?.extra?.number_dishes?.value || "");
    const [photosPerDishes, setphotosPerDishes] = useState<string>(values?.extra?.photos_per_dishes?.value || "");
    const [numberDrinks, setNumberDrinks] = useState<string>(values?.extra?.number_drinks?.value || "");
    const [photosPerDrinks, setPhotosPerDrinks] = useState<string>(values?.extra?.photos_per_drinks?.value || "");

    const briefing = `Informações de pratos\nNúmero de pratos para fotografar: ${
        values?.extra?.number_dishes?.value || numberDishes
    }\nNúmero de fotos por pratos: ${
        values?.extra?.photos_per_dishes?.value || photosPerDishes
    }\n\nInformações de bebidas\nNúmero de bebidas para fotografar: ${
        values?.extra?.number_drinks?.value || numberDrinks
    }\nNúmero de fotos por bebida: ${values?.extra?.photos_per_drinks?.value || photosPerDrinks}`;

    const handleExtraFieldChange = async (name: string, value: any) => {
        if (Object.keys(extraFields).includes(name)) {
            handleChange(name, { ...extraFields[name], value, type: extraFields[name].type }, { extra: true });
        }
    };

    const validateAndNextStep = () => {
        if ((!numberDishes.length || !photosPerDishes.length) && (!numberDrinks.length || !photosPerDrinks.length)) {
            return toast.error("As informações de pratos ou bebidas precisam ser preenchidas!");
        }

        if (confirmationStep) {
            updateValuesInLocalStorage();
            return goToStep(confirmationStep);
        }

        return nextStep();
    };

    useEffect(() => {
        const localValues = JSON.parse(localStorage.getItem("values"));
        if (confirmationStep) {
            setValues(localValues);
        }
    }, []);

    useEffect(() => {
        handleChange("briefing", briefing);
    }, [briefing]);

    return (
        <>
            <Header>
                <h1>Defina o briefing do seu job</h1>
                <p>Precisamos de algumas informações para realizar o seu job!</p>
            </Header>

            <Content>
                <div className="title">
                    <p>Informações de pratos</p>
                    <div className="bar" />
                    <Row className="input-content">
                        <Col lg={6}>
                            <NumberInput
                                name="number_dishes"
                                label="Número de pratos para fotografar"
                                value={numberDishes}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setNumberDishes(value);
                                }}
                            />
                        </Col>

                        <Col lg={6}>
                            <NumberInput
                                name="photos_per_dishes"
                                label="Número de fotos por pratos"
                                value={photosPerDishes}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setphotosPerDishes(value);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </Content>
            <Content>
                <div className="title">
                    <p>Informações de bebidas</p>
                    <div className="bar" />
                    <Row className="input-content">
                        <Col lg={6}>
                            <NumberInput
                                name="number_drinks"
                                label="Número de bebidas para fotografar"
                                value={numberDrinks}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setNumberDrinks(value);
                                }}
                            />
                        </Col>

                        <Col lg={6}>
                            <NumberInput
                                name="photos_per_drinks"
                                label="Número de fotos por bebida"
                                value={photosPerDrinks}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setPhotosPerDrinks(value);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </Content>
            <Content>
                <div className="title">
                    <p>Informações adicionais</p>
                    <div className="bar" />
                    <TextareaInput
                        name="adicional_info"
                        value={addicionalInfo}
                        placeholder="Descreva aqui qualquer informação adicional..."
                        rows={3}
                        onChange={(name: string, value: string) => {
                            handleExtraFieldChange(name, value);
                            setAddicionalInfo(value);
                        }}
                    />
                </div>
            </Content>

            <Footer>
                {confirmationStep ? (
                    <Button block onClick={validateAndNextStep}>
                        Salvar
                    </Button>
                ) : (
                    <>
                        <Button id="clickSegmentNext" block onClick={() => handleChange("category", 0)}>
                            Voltar
                        </Button>
                        <Button id="clickSegmentNext" block onClick={validateAndNextStep}>
                            Continuar
                        </Button>
                    </>
                )}
            </Footer>
        </>
    );
};

export default Foods;
